import { cn } from "cn"
import { Circle, CircleAlert, CircleCheck, CircleX, LoaderCircle, type LucideIcon } from "lucide-react"

const TONES: Record<StatusTone, { Icon: LucideIcon; className: string }> = {
  success: { Icon: CircleCheck, className: "text-success" },
  warning: { Icon: CircleAlert, className: "text-warning" },
  error: { Icon: CircleX, className: "text-destructive" },
  processing: { Icon: LoaderCircle, className: "animate-spin text-processing" },
  neutral: { Icon: Circle, className: "text-subtle-foreground" },
}

export type StatusTone = "success" | "warning" | "error" | "processing" | "neutral"

/**
 * An icon for a status. It supports a text label next to it; without one, pass `label`
 * so screen readers hear the status.
 */
export function StatusIcon({ tone, label, className }: { tone: StatusTone; label?: string; className?: string }) {
  const { Icon, className: toneClassName } = TONES[tone]

  return (
    <Icon
      className={cn("size-4 shrink-0", toneClassName, className)}
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    />
  )
}
